import React, {useRef, useEffect} from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default function HtmlEditor({replyHtml, onChange}) {
    const quillRef = useRef(null);

    useEffect(() => {
        if (replyHtml && quillRef.current) {
            const editor = quillRef.current.getEditor();
            editor.setContents([]);
            editor.clipboard.dangerouslyPasteHTML(0, replyHtml);
            editor.setSelection(0); // Move cursor to top
        }
    }, [replyHtml]);

    return (
        <div className="form-group row align-items-center mb-3">
            <label className="col-sm-2 col-form-label">Message:</label>
            <div style={{padding: 0}} className="col-sm-10">
                <ReactQuill
                    ref={quillRef}
                    theme="snow"
                    onChange={onChange}
                    style={{height: '300px', borderRadius: '4px', overflowY: "visible"}}
                />
            </div>
        </div>
    );
}
